//-------------------------------------------------
//Comment Format - Initials_yyyyMMdd - Comment
//Example        - CRN_20241028 - This is a Comment
//-------------------------------------------------

//CRN_20241016 - Leave `export const` on line 8 so an easy comparision with `environment.ts` can be made

export const environment = {
  eSimApi                  : 'https://suresim-platform-api.azurewebsites.net/api/',
  eSimApiWithoutApiPath    : 'https://suresim-platform-api.azurewebsites.net/',
  inviewApiKeyValue        : '00000000-0000-0000-0000-000000000000',
  outputErrorsToConsole    : false,
  platformMode             : false, //CRN_20260407 - For demo/research/visualEffects only
  platformModeInview       : false,
  production               : true,
  removeErrorPrefix        : true,
  risklineConfig           : {
    alertSignalrHubPath    : 'hubs/riskline-alerts',
    defaultLanguage        : 'en',
    enabled                : true,
    pollFallbackIntervalMs : 60000,
    tripReadyLandingBaseUrl: 'https://trip-ready.riskline.com/destination/'
  },
  ssoLoginCheckPoll        : 2000,
  sureSimClientId_Microsoft: '1171bb8d-3db7-4d53-8e59-7eed39e8ceb6',
  sureSimRootUrl           : 'https://portal.suresim.co.uk/',
  useSessionStorage        : true,
  webbingConfig            : {
    apiKeyName : 'ApiKey',
    apiKeyValue: 'pZRqvuEpoYqS/JLoqXEuDPYubjDvvsgHqc09GYOkGiQ='
  },
};
